(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["toycart-reviews"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tc-reviews')) {
  customElements.define('tc-reviews', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized) return;
      this.dataset.initialized = 'true';

      const success = this.querySelector('.tc-reviews__success, .tc-reviews__errors');
      if (success) {
        const details = success.closest('details');
        if (details) details.open = true;
      }
      try {
        this.labels = JSON.parse(this.querySelector('[data-tc-review-labels]').textContent);
        const localItems = JSON.parse(this.querySelector('[data-tc-local-reviews]').textContent);
        this.localReviewItems = Array.isArray(localItems) ? localItems : [];
        const localSource = JSON.parse(this.querySelector('[data-tc-review-source]').textContent) || {};
        this.feedData = { source_name: localSource.label || '', source_url: localSource.url || '' };
        this.reviews = this.normalizeReviews(this.localReviewItems);
        this.feedSettled = false;
        this.feedResult = 'pending';
      } catch {
        return;
      }
      this.feed = this.querySelector('[data-tc-review-feed]');
      this.summary = this.querySelector('[data-tc-review-summary]');
      this.cards = this.querySelector('[data-tc-review-cards]');
      this.status = this.querySelector('[data-tc-review-status]');
      this.sortControl = this.querySelector('[data-tc-review-sort]');
      this.ratingControl = this.querySelector('[data-tc-review-rating]');
      this.photoControl = this.querySelector('[data-tc-review-photos]');
      this.moreButton = this.querySelector('[data-tc-review-more]');
      this.dialog = this.querySelector('[data-tc-review-lightbox]');
      [this.sortControl, this.ratingControl, this.photoControl].forEach(control => {
        control.addEventListener('change', () => {
          this.visibleLimit = 12;
          this.renderReviews();
        });
      });
      this.moreButton.addEventListener('click', () => {
        this.visibleLimit += 12;
        this.renderReviews();
      });
      this.querySelector('[data-tc-lightbox-close]').addEventListener('click', () => this.dialog.close());
      this.querySelector('[data-tc-lightbox-prev]').addEventListener('click', () => this.movePhoto(-1));
      this.querySelector('[data-tc-lightbox-next]').addEventListener('click', () => this.movePhoto(1));
      this.dialog.addEventListener('click', event => {
        if (event.target === this.dialog) this.dialog.close();
      });
      this.dialog.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.movePhoto(-1);
        }
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.movePhoto(1);
        }
      });
      this.querySelector('[data-tc-lightbox-image]').addEventListener('error', () => {
        this.querySelector('[data-tc-lightbox-image]').hidden = true;
        this.querySelector('[data-tc-lightbox-fallback]').hidden = false;
      });
      this.dialog.addEventListener('close', () => {
        this.querySelector('[data-tc-lightbox-image]').removeAttribute('src');
        this.photoOpener?.focus();
      });
      this.visibleLimit = 12;
      this.feed.hidden = false;
      this.querySelector('[data-tc-review-legacy]').hidden = true;
      this.querySelector('[data-tc-review-toolbar]').hidden = this.reviews.length === 0;
      this.querySelector('[data-tc-photo-count]').textContent = '(' + this.reviews.filter(review => this.availablePhotos(review).length).length + ')';
      this.renderSummary();
      this.renderReviews();
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) {
            this.observer.disconnect();
            this.loadFeed();
          }
        }, { rootMargin: '500px 0px' });
        this.observer.observe(this);
      } else {
        this.loadFeed();
      }
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      if (this.dialog?.open) this.dialog.close();
    }
    label(key, values = {}) {
      let output = this.labels[key] || '';
      Object.entries(values).forEach(([name, value]) => {
        output = output.replace(new RegExp('\\{\\{\\s*' + name + '\\s*\\}\\}', 'g'), String(value)).split('__tc_' + name + '__').join(String(value));
      });
      return output;
    }
    element(tag, className, text) {
      const node = document.createElement(tag);
      if (className) node.className = className;
      if (text !== undefined) node.textContent = text;
      return node;
    }
    httpsUrl(value) {
      try {
        const url = new URL(value);
        if (url.protocol === 'https:' && !url.username && !url.password) return url.href;
      } catch {}
      return '';
    }
    sourceLink(url, text) {
      const link = this.element('a', '', text);
      link.href = url;
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      return link;
    }
    normalizeReviews(items) {
      const seen = new Set();
      return items.flatMap((review, index) => {
        if (!review || !['brand', 'toycart'].includes(review.origin) || review.approved !== true || review.permission_granted !== true || review.product_match !== true) return [];
        const rating = Number(review.rating);
        if (!Number.isInteger(rating) || rating < 1 || rating > 5) return [];
        const isToycart = review.origin === 'toycart';
        const sourceName = isToycart ? 'Toycart' : String(review.source_name || this.feedData.source_name || '').trim();
        const sourceUrl = isToycart ? this.httpsUrl(this.dataset.productUrl) : this.httpsUrl(review.source_url || this.feedData.source_url);
        if (!sourceName || !sourceUrl) return [];
        const photos = (Array.isArray(review.photos) ? review.photos : []).flatMap(photo => {
          const item = typeof photo === 'string' ? { url: photo } : photo;
          if (!item) return [];
          const url = this.httpsUrl(item.url);
          return url ? [{ url, alt: String(item.alt || ''), caption: String(item.caption || '').trim(), failed: false, thumbnailUrl: this.httpsUrl(item.thumbnail_url) || url, width: Number(item.width) || 600, height: Number(item.height) || 600 }] : [];
        });
        const body = String(review.body || '').trim();
        const title = String(review.title || '').trim();
        const author = String(review.author || '').trim() || this.label('author_fallback');
        const publishedAt = String(review.published_at || '');
        const dateNumber = Date.parse(publishedAt);
        const identity = review.id ? review.origin + ':' + sourceName + ':' + review.id : JSON.stringify([sourceName, author, rating, body, title, publishedAt, photos.map(photo => photo.url)]);
        if (seen.has(identity)) return [];
        seen.add(identity);
        return [{ origin: review.origin, originalSourceLabel: String(review.original_source_label || '').trim(), verificationSource: String(review.verification_source_name || sourceName), rating, sourceName, sourceUrl, photos, body, title, author, publishedAt, dateNumber: Number.isFinite(dateNumber) ? dateNumber : 0, sourceVerified: isToycart ? review.verified_purchase === true : review.source_verified_purchase === true, sourceIncentivized: review.source_incentivized === true, index }];
      });
    }
    async loadFeed() {
      if (this.loading || this.loaded || !this.dataset.feedUrl) return;
      this.loading = true;
      this.feedResult = 'unavailable';
      try {
        const response = await fetch(this.dataset.feedUrl, { credentials: 'omit' });
        if (!response.ok) return;
        const data = await response.json();
        if (data.schema_version !== 1 || !Array.isArray(data.reviews)) return;
        const numericId = String(data.product_id || '').split('/').pop();
        if (numericId !== this.dataset.productId || data.product_handle !== this.dataset.productHandle) return;
        this.feedData = data;
        this.reviews = this.normalizeReviews([...data.reviews.filter(review => review?.origin === 'brand'), ...this.localReviewItems]);
        this.loaded = true;
        this.feedResult = 'ready';
        this.visibleLimit = 12;
        this.querySelector('[data-tc-review-legacy]').hidden = true;
        this.feed.hidden = false;
        this.querySelector('[data-tc-review-toolbar]').hidden = this.reviews.length === 0;
        this.querySelector('[data-tc-photo-count]').textContent = '(' + this.reviews.filter(review => this.availablePhotos(review).length).length + ')';
      } catch {
        this.reviews = this.normalizeReviews(this.localReviewItems);
      } finally {
        this.loading = false;
        this.feedSettled = true;
        this.renderSummary();
        this.renderReviews();
      }
    }
    stars(rating) {
      const stars = this.element('span', 'tc-reviews__stars');
      stars.role = 'img';
      stars.setAttribute('aria-label', this.label('rating_label', { rating }));
      for (let value = 1; value <= 5; value += 1) {
        const star = this.element('span', value > Math.round(rating) ? 'tc-reviews__star-empty' : '', '★');
        star.setAttribute('aria-hidden', 'true');
        stars.append(star);
      }
      return stars;
    }
    renderSummary() {
      this.summary.replaceChildren();
      const total = this.reviews.length;
      const origin = this.element('div', 'tc-reviews__feed-origin');
      if (this.reviews.some(review => this.availablePhotos(review).length)) origin.append(this.element('p', 'tc-reviews__photo-disclosure', this.label('photo_disclosure')));
      const coverage = this.feedData.coverage || {};
      if (total > 0 && coverage.complete === false) origin.append(this.element('p', 'tc-reviews__coverage', this.label('source_coverage_partial')));
      if (!total) {
        const sourceUrl = this.httpsUrl(this.feedData.source_url);
        if (sourceUrl) origin.append(this.sourceLink(sourceUrl, this.label('source_link')));
      }
      if (!total) {
        this.summary.append(origin);
        return;
      }
      const mean = this.reviews.reduce((sum, review) => sum + review.rating, 0) / total;
      const score = this.element('div', 'tc-reviews__score');
      const number = this.element('p', 'tc-reviews__score-number');
      number.append(this.element('strong', '', mean.toFixed(1)), this.element('span', '', this.label('out_of_five')));
      score.append(number, this.stars(Number(mean.toFixed(1))), this.element('p', 'tc-reviews__score-count', this.label('review_count', { count: total })), this.element('p', 'tc-reviews__score-count', this.label('photo_count', { count: this.reviews.filter(review => this.availablePhotos(review).length).length })));
      const distribution = this.element('ul', 'tc-reviews__distribution');
      distribution.setAttribute('aria-label', this.label('rating_distribution'));
      for (let rating = 5; rating >= 1; rating -= 1) {
        const count = this.reviews.filter(review => review.rating === rating).length;
        const item = this.element('li');
        const button = this.element('button');
        button.type = 'button';
        button.dataset.rating = String(rating);
        button.setAttribute('aria-label', this.label('rating_label', { rating }) + ': ' + count);
        button.setAttribute('aria-pressed', String(this.ratingControl.value === String(rating)));
        const track = this.element('span', 'tc-reviews__rating-track');
        const fill = this.element('span', 'tc-reviews__rating-fill');
        fill.style.width = ((count / total) * 100).toFixed(2) + '%';
        track.append(fill);
        button.append(this.element('span', '', rating + ' ★'), track, this.element('span', '', String(count)));
        button.addEventListener('click', () => {
          this.ratingControl.value = this.ratingControl.value === String(rating) ? 'all' : String(rating);
          this.visibleLimit = 12;
          this.renderReviews();
        });
        item.append(button);
        distribution.append(item);
      }
      this.summary.append(score, distribution, origin);
    }
    formatDate(value) {
      const date = new Date(value);
      if (!Number.isFinite(date.getTime())) return '';
      return new Intl.DateTimeFormat(document.documentElement.lang || 'en', { year: 'numeric', month: 'short', day: 'numeric', timeZone: 'UTC' }).format(date);
    }
    renderReviews() {
      const ratingFilter = this.ratingControl.value;
      const filtered = this.reviews.filter(review => (ratingFilter === 'all' || review.rating === Number(ratingFilter)) && (!this.photoControl.checked || this.availablePhotos(review).length > 0));
      const mode = this.sortControl.value;
      filtered.sort((a, b) => {
        if (mode === 'photos') return Number(this.availablePhotos(b).length > 0) - Number(this.availablePhotos(a).length > 0) || b.dateNumber - a.dateNumber || a.index - b.index;
        if (mode === 'highest') return b.rating - a.rating || b.dateNumber - a.dateNumber || a.index - b.index;
        if (mode === 'lowest') return a.rating - b.rating || b.dateNumber - a.dateNumber || a.index - b.index;
        return b.dateNumber - a.dateNumber || a.index - b.index;
      });
      this.cards.replaceChildren();
      const visible = filtered.slice(0, this.visibleLimit);
      const fragment = document.createDocumentFragment();
      visible.forEach(review => fragment.append(this.reviewCard(review)));
      this.cards.append(fragment);
      this.status.textContent = this.reviews.length === 0 ? this.label(!this.feedSettled ? 'loading_reviews' : this.feedResult === 'ready' ? 'feed_empty' : 'reviews_unavailable') : filtered.length === 0 ? this.label('filter_empty') : this.label('results_count', { visible: visible.length, total: filtered.length });
      this.moreButton.hidden = visible.length >= filtered.length;
      this.summary.querySelectorAll('[data-rating]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.rating === ratingFilter)));
    }
    reviewCard(review) {
      const card = this.element('article', 'tc-reviews__card');
      const head = this.element('div', 'tc-reviews__card-head');
      const avatar = this.element('span', 'tc-reviews__avatar', Array.from(review.author)[0].toUpperCase());
      avatar.setAttribute('aria-hidden', 'true');
      const identity = this.element('div');
      identity.append(this.element('strong', '', review.author));
      const metadata = this.element('div', 'tc-reviews__metadata');
      const source = review.origin === 'toycart' ? this.element('span', '', 'Toycart') : this.sourceLink(review.sourceUrl, review.sourceName);
      source.className = 'tc-reviews__source-pill';
      const sourceDescription = this.label('source_accessible', { source: review.sourceName }) + (review.originalSourceLabel ? '. ' + review.originalSourceLabel : '');
      source.title = sourceDescription;
      source.setAttribute('aria-label', sourceDescription);
      metadata.append(source);
      if (review.sourceVerified) {
        const badge = this.element('span', 'tc-reviews__compact-badge', this.label('verified_short'));
        const verification = this.label('verification_by_source', { source: review.verificationSource });
        badge.title = verification;
        badge.setAttribute('aria-label', verification);
        metadata.append(badge);
      }
      if (review.sourceIncentivized) {
        const badge = this.element('span', 'tc-reviews__compact-badge tc-reviews__compact-badge--incentive', this.label('incentivized_short'));
        const incentive = this.label('incentive_by_source', { source: review.sourceName });
        badge.title = incentive;
        badge.setAttribute('aria-label', incentive);
        metadata.append(badge);
      }
      identity.append(metadata);
      head.append(avatar, identity);
      if (review.dateNumber) {
        const time = this.element('time', '', this.formatDate(review.publishedAt));
        time.dateTime = new Date(review.dateNumber).toISOString().slice(0, 10);
        head.append(time);
      }
      card.append(head, this.stars(review.rating));
      if (review.title) card.append(this.element('h3', '', review.title));
      const availablePhotos = this.availablePhotos(review);
      if (availablePhotos.length) {
        const gallery = this.element('div', 'tc-reviews__photos');
        availablePhotos.forEach((photo, index) => {
          const figure = this.element('figure', 'tc-reviews__photo-item' + (photo.caption ? ' tc-reviews__photo-item--captioned' : ''));
          const button = this.element('button', 'tc-reviews__photo');
          button.type = 'button';
          button.setAttribute('aria-label', this.label('photo_alt', { index: index + 1, author: review.author }));
          const image = this.element('img');
          image.src = photo.thumbnailUrl;
          image.alt = photo.alt || this.label('photo_alt', { index: index + 1, author: review.author });
          image.width = photo.width;
          image.height = photo.height;
          image.loading = 'lazy';
          image.decoding = 'async';
          image.referrerPolicy = 'no-referrer';
          image.addEventListener('error', () => {
            if (image.src !== photo.url && !photo.thumbnailRetried) {
              photo.thumbnailRetried = true;
              image.src = photo.url;
              return;
            }
            photo.failed = true;
            figure.hidden = true;
            if (!this.photoFailureRefresh) {
              this.photoFailureRefresh = true;
              requestAnimationFrame(() => {
                this.photoFailureRefresh = false;
                this.querySelector('[data-tc-photo-count]').textContent = '(' + this.reviews.filter(item => this.availablePhotos(item).length).length + ')';
                this.renderSummary();
                this.renderReviews();
              });
            }
          });
          button.append(image);
          button.addEventListener('click', () => this.openPhoto(review, index, button));
          figure.append(button);
          if (photo.caption) figure.append(this.element('figcaption', '', photo.caption));
          gallery.append(figure);
        });
        card.append(gallery);
      }
      if (review.photos.some(photo => photo.failed)) card.append(this.sourceLink(review.sourceUrl, this.label('photo_unavailable')));
      if (review.body) {
        const shortened = review.body.length > 600;
        const body = this.element('p', 'tc-reviews__review-body', shortened ? review.body.slice(0, 600).trimEnd() + '…' : review.body);
        card.append(body);
        if (shortened) {
          const toggle = this.element('button', 'tc-reviews__body-toggle', this.label('read_more'));
          toggle.type = 'button';
          toggle.setAttribute('aria-expanded', 'false');
          toggle.addEventListener('click', () => {
            const expanded = toggle.getAttribute('aria-expanded') !== 'true';
            toggle.setAttribute('aria-expanded', String(expanded));
            toggle.textContent = this.label(expanded ? 'read_less' : 'read_more');
            body.textContent = expanded ? review.body : review.body.slice(0, 600).trimEnd() + '…';
          });
          card.append(toggle);
        }
      }
      return card;
    }
    availablePhotos(review) {
      return review.photos.filter(photo => !photo.failed);
    }
    openPhoto(review, index, opener) {
      this.activePhotoReview = review;
      this.activePhotoIndex = index;
      this.photoOpener = opener;
      this.renderPhoto();
      if (!this.dialog.open) this.dialog.showModal();
    }
    movePhoto(direction) {
      if (!this.activePhotoReview) return;
      const total = this.availablePhotos(this.activePhotoReview).length;
      this.activePhotoIndex = (this.activePhotoIndex + direction + total) % total;
      this.renderPhoto();
    }
    renderPhoto() {
      const review = this.activePhotoReview;
      const photos = this.availablePhotos(review);
      if (photos.length === 0) { this.dialog.close(); return; }
      const photo = photos[this.activePhotoIndex];
      const image = this.querySelector('[data-tc-lightbox-image]');
      image.hidden = false;
      image.src = photo.url;
      image.alt = photo.alt || this.label('photo_alt', { index: this.activePhotoIndex + 1, author: review.author });
      image.referrerPolicy = 'no-referrer';
      const note = this.querySelector('[data-tc-lightbox-note]');
      note.textContent = photo.caption;
      note.hidden = !photo.caption;
      const fallback = this.querySelector('[data-tc-lightbox-fallback]');
      fallback.href = review.sourceUrl;
      fallback.hidden = true;
      this.querySelector('[data-tc-lightbox-caption]').textContent = this.label('photo_caption', { author: review.author, source: review.sourceName });
      this.querySelector('[data-tc-lightbox-position]').textContent = this.label('photo_position', { index: this.activePhotoIndex + 1, total: photos.length });
      this.querySelector('[data-tc-lightbox-prev]').hidden = photos.length < 2;
      this.querySelector('[data-tc-lightbox-next]').hidden = photos.length < 2;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
